import React from "react";
import "./Hero.css";
import HomeScreen from "../../assests/home_screen.jpg";
import PhoneMockup from "../PhoneMockup/PhoneMockup";
import { Link as ScrollLink } from "react-scroll";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-left">
        <div className="hero-pill">
          <span className="hero-pill-dot"></span>
          Bank Transfers · Bills · Crypto
        </div>

        <h1 className="hero-headline">
          The smarter way<br />
          to <span className="hero-accent">send money.</span>
        </h1>

        <p className="hero-sub">
          Bank transfers, bill payments and crypto — all in one app.
          Works seamlessly whether you're online or completely offline.
        </p>

        <div className="hero-actions">
          <a href="https://onelink.to/n9hyxn" target="_blank" rel="noreferrer">
            <button className="hero-btn-fill">Download App</button>
          </a>
          <ScrollLink to="services" smooth={true} duration={500}>
            <button className="hero-btn-outline">See Features</button>
          </ScrollLink>
        </div>

        <div className="hero-trust">
          <span><strong>10K+</strong> Users</span>
          <span className="trust-sep"></span>
          <span><strong>Zero</strong> Hidden Fees</span>
          <span className="trust-sep"></span>
          <span><strong>99.9%</strong> Uptime</span>
        </div>
      </div>

      <div className="hero-right">
        {/* Purple circle behind phone */}
        <div className="hero-phone-orbit"></div>

        {/* Floating card — transfer */}
        <div className="hero-card hero-card-transfer">
          <div className="hc-row">
            <div className="hc-icon hc-icon-green">&#10003;</div>
            <div>
              <div className="hc-title">Transfer Sent</div>
              <div className="hc-sub">John Doe · GTBank</div>
            </div>
          </div>
          <div className="hc-amount">&#8358;50,000</div>
        </div>

        {/* Phone mockup */}
        <PhoneMockup
          screenshot={HomeScreen}
          alt="Sendcheap home screen"
          size="md"
          className="hero-pm"
        />

        {/* Floating card — offline */}
        <div className="hero-card hero-card-offline">
          <div className="hc-offline-dot"></div>
          <span>Offline Mode Active</span>
        </div>

        {/* Floating card — crypto */}
        <div className="hero-card hero-card-crypto">
          <div className="hc-coins">
            <span className="hc-coin" style={{ background: "#f7931a" }}>&#8383;</span>
            <span className="hc-coin" style={{ background: "#627eea" }}>&#926;</span>
            <span className="hc-coin" style={{ background: "#26a17b" }}>&#8366;</span>
          </div>
          <span className="hc-crypto-label">Crypto Accepted</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
